<ng-container *ngIf="navItem && navItem.path">
  <ng-container
    *ngIf="
      navItem.title === 'Review Patient Feedback' && !hasChcpPatientReviews;
      else NonBrighterNavItem
    "
  >
    <button
      type="button"
      cignaButton="link"
      (click)="checkFederation()"
      [class.top-link]="isTopLevel"
      [class.child-link]="!isTopLevel"
      [class.cg-disabled-link]="isImpersonator"
      [class.cg-non-clickable]="isImpersonator"
      [attr.data-test-id]="
        dataTestAttribute ? dataTestAttribute : navItem.identifier
      "
      [cignaTrackClicks]="[
        'trackEventOther',
        navItem.title,
        isTopLevel ? 'ac-NV003-Primary Nav' : 'ac-NV004-Secondary Nav',
        { prop20: isTopLevel ? 'nav-top-menu' : 'nav-sub-menu' }
      ]"
    >
      {{ navItem.title }}
    </button>
  </ng-container>
  <ng-template #NonBrighterNavItem>
    <a
      *ngIf="!navItem.openExternal; else externalLink"
      [routerLink]="routerLink"
      [queryParams]="getQueryParams(routerLink, navItem.title)"
      [class.top-link]="isTopLevel"
      [class.child-link]="!isTopLevel"
      [class.cg-disabled-link]="isImpersonator && !navItem.allowImpersonator"
      [class.cg-non-clickable]="isImpersonator && !navItem.allowImpersonator"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{ exact: false }"
      [attr.data-test-id]="
        dataTestAttribute ? dataTestAttribute : navItem.identifier
      "
      [cignaTrackClicks]="[
        'trackEventOther',
        navItem.title,
        isTopLevel ? 'ac-NV003-Primary Nav' : 'ac-NV004-Secondary Nav',
        { prop20: isTopLevel ? 'nav-top-menu' : 'nav-sub-menu' }
      ]"
    >
      <mat-icon
        *ngIf="isTopLevel && navItem.title === 'Manage User Access'"
        svgIcon="phosphor-regular-users-three"
        class="nav-user__img"
      ></mat-icon>
      {{ navItem.title }}

      <cigna-icon
        *ngIf="hasChildren"
        type="chevron-down-medium"
        class="nav-dropdown-icon"
      ></cigna-icon>
      <div
        class="unread-indicator"
        *ngIf="
          isTopLevel &&
          navItem.title === 'Manage User Access' &&
          hasWamApproval &&
          isEnhInvUserFlow
        "
      >
        <span data-test-id="span-unread-dot" class="unread-dot"></span>
      </div>
      <ng-leaf-badge
        *ngIf="navItem?.newTitle"
        [status]="'notification'"
        [text]="'NEW'"
        [variant]="'strong'"
        class="new-keyword-icon"
      ></ng-leaf-badge>

      <ng-leaf-badge
        *ngIf="
          navItem.title === 'Awaiting approval' &&
          hasWamApproval &&
          isEnhInvUserFlow
        "
        [status]="'warning'"
        [text]="'You have users waiting for access'"
        [variant]="'strong'"
        style="display: block"
      ></ng-leaf-badge>
    </a>
  </ng-template>

  <ng-template #externalLink>
    <ng-container
      *ngIf="navItem.path.includes('resourceLibrary'); else externalDefault"
    >
      <a
        [class.top-link]="isTopLevel"
        [class.child-link]="!isTopLevel"
        [href]="
          navItem.path
            | resourceLink : { type: 'page', targetApp: navItem.targetApp }
            | async
        "
        target="resourcesWindow"
        [attr.data-test-id]="
          dataTestAttribute ? dataTestAttribute : navItem.identifier
        "
        [cignaTrackClicks]="[
          'trackEventOther',
          navItem.title,
          isTopLevel ? 'ac-NV003-Primary Nav' : 'ac-NV004-Secondary Nav',
          { prop20: isTopLevel ? 'nav-top-menu' : 'nav-sub-menu' }
        ]"
      >
        {{ navItem.title }}
        <cigna-icon
          *ngIf="hasChildren"
          type="chevron-down-medium"
          class="nav-dropdown-icon"
        ></cigna-icon>
      </a>
    </ng-container>
    <ng-template #externalDefault>
      <a
        [class.top-link]="isTopLevel"
        [class.child-link]="!isTopLevel"
        [class.cg-disabled-link]="isImpersonator && !navItem.allowImpersonator"
        [class.cg-non-clickable]="isImpersonator && !navItem.allowImpersonator"
        [href]="navItem.path"
        target="_blank"
        rel="noopener"
        [attr.data-test-id]="
          dataTestAttribute ? dataTestAttribute : navItem.identifier
        "
        [cignaTrackClicks]="[
          'trackEventOther',
          navItem.title,
          isTopLevel ? 'ac-NV003-Primary Nav' : 'ac-NV004-Secondary Nav',
          { prop20: isTopLevel ? 'nav-top-menu' : 'nav-sub-menu' }
        ]"
      >
        {{ navItem.title }}
      </a>
    </ng-template>
  </ng-template>
</ng-container>
